<button (click)="openApp()">Open with Cortizo App</button>